module.exports = __webpack_public_path__ + "static/media/airbnb-logo-1.51872e0f.png";